// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__xBjWL","disabled":"Checkbox_disabled__S-F47","text":"Checkbox_text__pSgRJ"};